"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { signIn } from "next-auth/react";
import { Card, CardContent } from "@/components/ui/card";
import Image from 'next/image';

export default function LoginPage() {
	const searchParams = useSearchParams();
	const callbackUrl = searchParams.get('callbackUrl') || '/';
	const error = searchParams.get('error');

	useEffect(() => {
		try {
			const initiateLogin = async () => {
				try {
					if (!error) {
						await signIn('auth0', {
							callbackUrl,
							redirect: true
						});
					}
				} catch (err) {
					console.error('Login error:', err);
				}
			};

			initiateLogin();

		} catch (error) {
			alert("Error: " + error);
		}
	}, [callbackUrl, error]);

	return (
		<div className="flex items-center justify-center min-h-screen">
			<Card className="w-[350px] py-16 px-10 bg-white">
				<CardContent className="flex flex-col items-center justify-center p-6 bg-white">
					<Image
						src="/acrd-logo.png"
						alt="ACRD Logo"
						width={200}
						height={200}
						priority
						className="object-contain"
					/>
					<div className="flex flex-col items-center justify-center mt-5">
						{error ? (
							<>
								<p className="mt-4 text-red-500">Login error: {error}</p>
								<button
									onClick={() => signIn('auth0', { callbackUrl })}
									className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
								>
									Try Again
								</button>
							</>
						) : (
							<p className="mt-4 text-gray-500">Redirecting to login...</p>
						)}
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
